<template>
    <div
        class="mx-6 mb-12 max-w-screen-xl space-y-5 lg:mx-auto lg:my-12 lg:min-w-[1024px]"
    >
        <div>
            <span class="text-xl text-gray-700">{{
                t('checkoutSuccess.thanks')
            }}</span>
            <div class="my-2 text-4xl font-bold text-gray-900">
                {{ t('checkoutSuccess.successfulOrder') }}
            </div>
            <p
                v-if="!isKiosk"
                class="mb-4 mt-0 p-0 text-xl text-gray-700"
            >
                {{ t('checkoutSuccess.seeYouSoon') }}
            </p>
            <div
                :style="{
                    height: '3px',
                    background:
                        'linear-gradient(90deg, rgb(var(--color-primary-600)) 0%, rgba(33, 150, 243, 0) 50%)'
                }"
            ></div>
        </div>

        <div
            class="flex flex-col sm:flex-row sm:items-center sm:justify-between"
        >
            <div class="mb-3 sm:mb-0">
                <span class="mr-2 text-xl font-medium text-gray-900">{{
                    t('checkoutSuccess.referenceNumber')
                }}</span>
                <span class="text-xl font-medium text-primary-500"
                    >#{{ refNumber }}</span
                >
            </div>
        </div>

        <div
            v-if="!isKiosk"
            class="flex justify-end"
        >
            <nuxt-link :to="facilityHome">
                <prime-button
                    :label="t('checkoutSuccess.returnToHomepage')"
                    icon="pi pi-fw pi-arrow-left"
                    severity="secondary"
                />
            </nuxt-link>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue'
import PrimeButton from 'primevue/button'
import nuxtLink from '#app/components/nuxt-link'
import { computed } from 'vue'
import { useRouteLink } from '~/composables/routing'
import { useActiveFacility } from '~/composables/use-active-facility'
import { useLayoutMode } from '~/composables/use-layout-mode'
import { useI18n } from 'vue-i18n'

defineProps<{
    refNumber: number
}>()

const { t } = useI18n({ useScope: 'global' })

useHead({
    title: t('success')
})

const { isKiosk } = useLayoutMode()
const activeFacility = useActiveFacility()
const { facilityHomeLink } = useRouteLink()
const facilityHome = computed(() => facilityHomeLink(activeFacility.value.slug))
</script>
